import React, { Component } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { Button, Table, Row, Col } from 'components/ui';
import { ConfirmDelete, Loading } from 'components/blocks';
import { showErrorNotification } from 'services/common';
import CategoryEditorModal from './CategoryEditorModal';
import './style.css';

class Categories extends Component {
  state = {
    showEditCategoryModal: false,
    showConfirmDeleteModal: false,
    showApiKeysModal: false,
    activeCategoryId: -1,
  };

  componentDidUpdate(prevProps) {
    this.showErrors(prevProps);
  }

  showErrors = prevProps => {
    if (this.props.error && prevProps.error !== this.props.error) {
      showErrorNotification(this.props.error);
    }
  };

  handleAddCategory = () => {
    this.setState({
      activeCategoryId: -1,
      showEditCategoryModal: true,
    });
  };

  handleEditCategory = event => {
    let { id } = event.target;
    id = Number(id.replace('edit-', ''));
    this.setState({
      activeCategoryId: id,
      showEditCategoryModal: true,
    });
  };

  handleDeleteCategory = event => {
    let { id } = event.target;
    id = Number(id.replace('delete-', ''));
    this.setState({
      activeCategoryId: id,
      showConfirmDeleteModal: true,
    });
  };

  handleShowApiKeys = event => {
    let { id } = event.target;
    id = Number(id.replace('api-key-', ''));
    this.setState({
      activeCategoryId: id,
      showApiKeysModal: true,
    });
  };

  handleConfirmDeleteCategory = () => {
    this.handleHideConfirmDelete();
    this.props.onDeleteCategory(this.state.activeCategoryId);
  };

  handleHideEditCategoryModal = () => {
    this.setState({ showEditCategoryModal: false });
  };

  handleHideApiKeysModal = () => {
    this.setState({ showApiKeysModal: false });
  };

  handleHideConfirmDelete = () => {
    this.setState({ showConfirmDeleteModal: false });
  };

  handleAddOrEditCategory = category => {
    const { onAddCategory, onEditCategory } = this.props;
    const isNewCategory = this.state.activeCategoryId < 0;
    const saveFunction = isNewCategory ? onAddCategory : onEditCategory;
    this.handleHideEditCategoryModal();
    saveFunction(category);
  };

  getActiveCategory = () => {
    const { categories } = this.props;
    const activeCategoryId = Number(this.state.activeCategoryId);
    return find(categories, { id: activeCategoryId }) || {};
  };

  getTableColumns = () => [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Target',
      dataIndex: 'targetType',
      key: 'targetType',
      render: data => {
        return data.toUpperCase();
      },
    },
    {
      title: 'actions',
      dateIndex: 'actions',
      key: 'actions',
      render: ({ key }) => (
        <Row className="categories__actions">
          <Col span={12}>
            <Button
              className="categories__edit-btn"
              id={`edit-${key}`}
              type="button"
              onClick={this.handleEditCategory}
            >
              Edit
            </Button>
          </Col>
          <Col span={12}>
            <Button
              className="categories__delete-btn"
              id={`delete-${key}`}
              type="button"
              onClick={this.handleDeleteCategory}
            >
              Delete
            </Button>
          </Col>
        </Row>
      ),
    },
  ];

  getTableData = () =>
    this.props.categories.map(category => ({
      key: category.id,
      name: category.name,
      targetType: category.target_type,
      actions: category.id,
    }));

  render() {
    const { categories, isLoading } = this.props;
    const {
      activeCategoryId,
      showEditCategoryModal,
      showConfirmDeleteModal,
      showApiKeysModal,
    } = this.state;
    const activeCategory = this.getActiveCategory();

    return (
      <div className="categories">
        <div className="flex items-center space-x-4">
          <Button
            id="new-category-modal-open-btn"
            onClick={this.handleAddCategory}
          >
            Create New category
          </Button>
          {isLoading && <Loading />}
        </div>
        <Table
          columns={this.getTableColumns()}
          dataSource={this.getTableData()}
        />
        <CategoryEditorModal
          categories={categories}
          category={activeCategory}
          isVisible={showEditCategoryModal}
          onHide={this.handleHideEditCategoryModal}
          onSaveCategory={this.handleAddOrEditCategory}
        />
        <ConfirmDelete
          description={`You are about to delete category ${activeCategory.name}. Do you wish to proceed?`}
          isVisible={showConfirmDeleteModal}
          title={`Delete Category ${activeCategory.name}?`}
          onConfirm={this.handleConfirmDeleteCategory}
          onHide={this.handleHideConfirmDelete}
        />
      </div>
    );
  }
}

Categories.defaultProps = {
  isLoading: false,
  categories: [],
};

Categories.propTypes = {
  error: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  onAddCategory: PropTypes.func.isRequired,
  onDeleteCategory: PropTypes.func.isRequired,
  onEditCategory: PropTypes.func.isRequired,
};

export default Categories;
